(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fl-freebie"] && !Shopify.designMode) return;
  try {
    
  // FLÜMER: Freebie-Formulare → Klaviyo-Listen (Client Subscription API, nur Public Key).
  //
  // Zwei Formularvarianten (Sektionseinstellung „Zustellung“):
  //   .fl-freebie__form--optin   (Double-Opt-in, Standard): einfaches <form>, geht NUR an Klaviyo. Klaviyo verschickt
  //                              die Bestätigungsmail (Double-Opt-in = Listen-Einstellung in Klaviyo), der Flow liefert
  //                              das PDF. Fehler → deutsche Fehlerzeile, Formular bleibt nutzbar. Kein nativer Fallback.
  //                              Zwei Fehlerarten (2026-10-19): „invalid“ nur bei Klaviyo-400 auf die E-Mail-Adresse
  //                              (rote Umrandung); alles andere – blockierte/abgebrochene Anfrage (Werbeblocker,
  //                              Privacy-Browser, gefiltertes Netz), Timeout, 429/5xx, fehlende Einstellungen – ist
  //                              „blocked“: Hinweis mit Kontaktadresse, ohne rote Umrandung.
  //   .fl-freebie__form--instant (Sofort-Download, alt): Shopify-Kundenformular; Klaviyo zuerst, bei Fehler oder ohne
  //                              Klaviyo-Einstellungen läuft das native Shopify-Formular (inkl. Captcha) weiter.
  //
  // Warum ein Capture-Listener auf window: Shopifys Storefront-Captcha hängt sich mit einem eigenen
  // submit-Listener an jedes Kundenformular, ruft preventDefault() auf, löst die hCaptcha-Prüfung aus und
  // schickt das Formular danach selbst nativ ab (Seiten-Reload). Der Capture-Listener auf window läuft vor
  // jedem Listener am Formular; stopImmediatePropagation() hält das Captcha im Klaviyo-Pfad komplett fern.
  // Nach Erfolg wird das <form> durch ein <div> ersetzt – ein evtl. doch noch ausgelöster nativer Submit
  // auf einem losgelösten Formular ist per Spezifikation ein No-op.
  if (!window.flFreebieKlaviyo) {
    window.flFreebieKlaviyo = true;

    const REVISION = '2026-07-15';
    const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    // Manche Blocker lassen die Anfrage hängen statt sie abzulehnen → nach 12 s abbrechen (→ „blocked“).
    const TIMEOUT_MS = 12000;

    const setBusy = (button, busy) => {
      if (!button) return;
      button.disabled = busy;
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    };

    // Sofort-Download (alt): nativ weiter (Shopify-Kundenformular inkl. Captcha, Seiten-Reload).
    const fallbackNative = (form, button) => {
      setBusy(button, false);
      form.dataset.flNative = 'true';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    };

    // Double-Opt-in: Fehlerzeile zeigen, Formular bleibt nutzbar. kind = 'invalid' | 'blocked'.
    //   invalid – Klaviyo hat die E-Mail-Adresse abgelehnt: --invalid einblenden, aria-invalid (rote Umrandung).
    //   blocked – alles andere: --blocked einblenden (Hinweis + Kontaktadresse), KEIN aria-invalid.
    // Die eingeblendete Zeile bekommt den Fokus (einmalige Ansage), daher kein zusätzliches role="alert".
    const showError = (form, button, kind) => {
      setBusy(button, false);
      const input = form.querySelector('input[type="email"]');
      const invalid = form.querySelector('.fl-freebie__error--invalid');
      const blocked = form.querySelector('.fl-freebie__error--blocked');
      const show = kind === 'invalid' ? invalid || blocked : blocked || invalid;
      if (!show) return;
      const hide = show === invalid ? blocked : invalid;
      if (hide) hide.hidden = true;
      show.hidden = false;
      if (input) {
        if (show === invalid) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
        if (show.id) input.setAttribute('aria-describedby', show.id);
      }
      show.focus();
    };

    // Nur Double-Opt-in: beide Fehlerzeilen sind vorgerendert und werden vor jedem Versuch wieder versteckt.
    const clearError = (form) => {
      if (!form.classList.contains('fl-freebie__form--optin')) return;
      const input = form.querySelector('input[type="email"]');
      if (input) {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      }
      form.querySelectorAll('.fl-freebie__error').forEach((error) => {
        error.hidden = true;
      });
    };

    const fail = (form, button, kind) => {
      if (form.classList.contains('fl-freebie__form--optin')) showError(form, button, kind || 'blocked');
      else fallbackNative(form, button);
    };

    // Nur ein Klaviyo-400, dessen Fehler auf das E-Mail-Attribut zeigt, ist ein Adressfehler
    // (Klaviyo: errors[0].source.pointer = "/data/attributes/profile/data/attributes/email").
    const isEmailError = (status, text) => {
      if (status !== 400) return false;
      try {
        const data = JSON.parse(text);
        const errors = data && Array.isArray(data.errors) ? data.errors : [];
        return errors.some((error) => {
          const pointer = String((error && error.source && error.source.pointer) || '');
          return /\/email$/.test(pointer) || pointer.indexOf('attributes/email') !== -1;
        });
      } catch (error) {
        return false;
      }
    };

    const done = (form) => {
      const template = form.querySelector('template.fl-freebie__done');
      if (!template) {
        fail(form, form.querySelector('button[type="submit"]'));
        return;
      }
      const foot = form.parentElement;
      const box = document.createElement('div');
      box.className = 'fl-freebie__form fl-freebie__form--done';
      box.setAttribute('role', 'status');
      box.appendChild(template.content.cloneNode(true));
      form.replaceWith(box);
      if (template.dataset.file && foot) {
        const note = foot.querySelector(':scope > .fl-freebie__note');
        if (note) note.hidden = true;
      }
      const message = box.querySelector('.fl-freebie__success');
      if (message) message.focus();
    };

    const subscribe = (form, key, list) => {
      const input = form.querySelector('input[type="email"]');
      const email = input ? input.value.trim() : '';
      const button = form.querySelector('button[type="submit"]');
      clearError(form);
      setBusy(button, true);
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.flSource || 'FLÜMER Shop',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                },
              },
            },
          },
          relationships: { list: { data: { type: 'list', id: list } } },
        },
      };
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      const timer = controller ? setTimeout(() => controller.abort(), TIMEOUT_MS) : 0;
      fetch(`${ENDPOINT}?company_id=${encodeURIComponent(key)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify(body),
        signal: controller ? controller.signal : undefined,
      })
        .then((response) => {
          clearTimeout(timer);
          if (response.status === 202 || response.ok) {
            done(form);
            return;
          }
          return response.text().then((text) => {
            console.warn(`[fl-freebie] Klaviyo ${response.status}: ${text}`);
            fail(form, button, isEmailError(response.status, text) ? 'invalid' : 'blocked');
          });
        })
        .catch((error) => {
          // Anfrage blockiert (Werbeblocker, DNS-Filter, CORS), offline oder Timeout → nicht die Adresse.
          clearTimeout(timer);
          console.warn('[fl-freebie] Klaviyo request failed', error);
          fail(form, button, 'blocked');
        });
    };

    window.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.classList.contains('fl-freebie__form')) return;
        if (form.dataset.flNative) return; // Fallback (nur Sofort-Download): nativ (Shopify-Kundenformular inkl. Captcha)
        const optin = form.classList.contains('fl-freebie__form--optin');
        const host = form.closest('fl-freebie-forms');
        const key = ((host && host.dataset.flKlaviyoKey) || '').trim();
        const list = (form.dataset.flKlaviyoList || '').trim();
        const input = form.querySelector('input[type="email"]');
        const valid = !!(input && input.value.trim() && input.checkValidity());

        if (!optin) {
          // Sofort-Download (alt): ohne Klaviyo-Einstellungen oder bei ungültiger Eingabe nativ weiterlaufen lassen.
          if (!key || !list || !valid) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          subscribe(form, key, list);
          return;
        }

        // Double-Opt-in: das Formular hat kein Ziel – immer abfangen.
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!valid) {
          if (input && typeof input.reportValidity === 'function') input.reportValidity();
          return;
        }
        if (!key || !list) {
          console.warn('[fl-freebie] Klaviyo Public Key oder Listen-ID fehlt (Theme-Einstellungen → FLÜMER → Klaviyo).');
          showError(form, form.querySelector('button[type="submit"]'), 'blocked');
          return;
        }
        subscribe(form, key, list);
      },
      true
    );
  }

  if (!customElements.get('fl-freebie-forms')) {
    customElements.define('fl-freebie-forms', class FlFreebieForms extends HTMLElement {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
